import Column from '@components/Column';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { BottomSheet } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { pressActionEffect } from '@styles/mixin';
import { useTranslation } from 'react-i18next';

declare module '@stackflow/config' {
    interface Register {
        EasyCardManageBottomSheet: {
            cardId: string;
        }
    }
}

const EasyCardManageBottomSheet: ActivityComponentType<'EasyCardManageBottomSheet'> = ({ params }) => {
    const { cardId } = params;
    const { t } = useTranslation('easyCard');
    const { replace } = useFlow();
    return (
        <BottomSheet>
            <Header>
                <Text size='title' fontWeight='bold'>
                    {t('manage.title')}
                </Text>
            </Header>
            <Container fullWidth>
                <MenuItem onClick={() => replace('EasyCardNameBottomSheet', { cardId })}>
                    <Text size='title' fontWeight='medium'>
                        {t('manage.rename')}
                    </Text>
                </MenuItem>
                <MenuItem onClick={() => replace('EasyCardDeleteModal', { cardId })}>
                    <Text size='title' fontWeight='medium'>
                        {t('manage.delete')}
                    </Text>
                </MenuItem>
            </Container>
        </BottomSheet>
    );
};

const Header = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    //height: 64px;
    padding: var(--spacing-5);
`;

const Container = styled(Column)`
    padding: var(--spacing-4) var(--spacing-4) calc(var(--spacing-4) + var(--safe-area-bottom));
`;

const MenuItem = styled.button`
    display: flex;
    align-items: center;
    width: 100%;
    padding: var(--spacing-3);
    background-color: transparent;
    ${pressActionEffect}
`;

export default EasyCardManageBottomSheet;
